<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Consulta las entregas incompletas a socios 
                de negocio por material. Verifica cantidades 
                solicitadas vs. atendidas y exporta para seguimiento.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Entregas Incompletas
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza y exporta las <b>entregas incompletas</b> a los <b>socios de negocio</b> por
          <b>material</b>.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <app-status-filters [selectedCustomerType]="selectedCustomerType"
            [showCustomerType]="['BPT9002','BPT9001','BPT0001']" (selectionFilterApply)="getList()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (SmartGrid) -->
      <div class="pt-1 mx-6">
        <!-- Smart Grid -->
        <div class="overflow-x-auto">
          <app-smart-grid
            [data]="data"
            [columnDefs]="columnDefs"
            [config]="gridConfig"
            [loading]="loading"
            [totalRecords]="totalItems"
            (gridReady)="onGridReady($event)"
            (pageChanged)="onPageChanged($event)"
            (sortChanged)="onSortChanged($event)">
          </app-smart-grid>
        </div>
      </div>
    </div>
  </div>

  <!--Filtros-->
  <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">

    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true" [showStartTrip]="true" [showEndTrip]="true"
        [showDeliveryDate]="true"></app-dates-filters>
    </app-filter-section>

    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
        [warehouse]="true" [loadData]="loadConfigData"></app-configuration-filters>
    </app-filter-section>

    <app-filter-section title="Documentos" [expanded]="false" (onExpanded)="onDocumentsExpanded()">
      <app-documents-filters [form]="form" [documentClass]="true" [typeDocumentClass]="type"
      [loadData]="loadDocumentsData"></app-documents-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters [form]="form" [assignedUser]="true" [payingBusinessPartner]="true"
        [receivingBusinessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
      <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
      [loadData]="loadMaterialsData">
      </app-materials-management-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>